import React, { useState } from "react";
import { Button, Col, Form, Row, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import { createAccountInitialValues as initialValues } from "./initialValues";
import { FormFields } from "./FormFields";
import { registerUser } from "../../http-request/user";
import Notification from "../../../components/shared/Notification";
import { COLORS, FullSpan } from "../../../constants";
import styles from "./styles/CreateAccountPage.module.css";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 20, color: COLORS.blue1 }} spin />
);

const FormCreateAccount = () => {
  const [isLoading, setisLoading] = useState(false);
  const [forms] = Form.useForm();
  return (
    <Form
      form={forms}
      {...FullSpan}
      initialValues={initialValues}
      onFinish={async (value) => {
        setisLoading(true);
        let token = localStorage.getItem("token");
        await registerUser(value, token)
          .then((res) => {
            if (res?.isRegistered) {
              Notification("User Successfully Registered", "", "success");
              forms.resetFields();
            }
          })
          .finally(() => setisLoading(false));
      }}
    >
      <div className={styles.info}>
        <FormFields {...forms} />

        <Row justify="start" style={{ margin: "20px 0 20px 0" }}>
          <Col
            span={12}
            style={{ justifyContent: "flex-start", display: "flex" }}
          >
            <Button
              htmlType="reset"
              style={{ border: 0, backgroundColor: COLORS.orange }}
            >
              DISCARD
            </Button>
          </Col>
          <Col
            span={12}
            style={{ justifyContent: "flex-end", display: "flex" }}
          >
            <Button disabled={isLoading} htmlType="submit" type="primary">
              {isLoading ? <Spin indicator={antIcon} /> : "SAVE"}
            </Button>
          </Col>
        </Row>
      </div>
    </Form>
  );
};

export default FormCreateAccount;
